import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { convertArrayToObject } from "../../../utils/helpers";
import { useResultsContext } from "../../../services/context/results-context";

/* const CustomItemTooltipContent = (props) => {
  const { itemData, series } = props;

  return (
    <Paper sx={{ padding: 3, backgroundColor: series.color }}>
      <p>{series.label}</p>
      <p>x: {series.data[itemData.dataIndex].x.toFixed(2)}</p>
      <p>y: {series.data[itemData.dataIndex].y.toFixed(2)}</p>
      <p>
        additional value: {series.data[itemData.dataIndex].other.toFixed(2)}
      </p>
      <p>
        other additional value:{" "}
        {series.data[itemData.dataIndex].other2.toFixed(2)}
      </p>
    </Paper>
  );
}; */

export const Chart = ({ areaBalance, isSurvey }) => {
  const { buildingsTypes } = useResultsContext();
  const buildingsTypesObj = convertArrayToObject(buildingsTypes, "id");

  const data = Object.entries(areaBalance).map(([key, value]) => ({
    id: key,
    value: value,
    label: buildingsTypesObj[key].display_name,
    color: buildingsTypesObj[key].color,
  }));

  const TOTAL = data.map((item) => item.value).reduce((a, b) => a + b, 0);

  const getArcLabel = (params) => {
    const percent = params.value / TOTAL;
    return `${(percent * 100).toFixed(0)}%`;
  };

  return (
    <PieChart
      series={[
        {
          arcLabel: getArcLabel,
          arcLabelMinAngle: 45,
          data: data,
          valueFormatter: (v, { dataIndex }) => {
            /*  const { rank } = data[dataIndex]; */
            return `${v.value.toFixed(2)} m²  (${((v.value / TOTAL) * 100).toFixed(0)}%)`;
          },
        },
      ]}
      /* series={[
        {
          data: data.map((d) => ({ label: d.team, id: d.team, value: d.points })),
          valueFormatter: (v, { dataIndex }) => {
            const { rank } = data[dataIndex];
            return `has ${v.value} points and is ranked ${rank}.`;
          },
        },
      ]} */
      /* slotProps={{ legend: { hidden: true } }} */
      margin={{ left: 10, right: 10 }}
      slotProps={{
        legend: {
          direction: "row",
          position: { vertical: "top", horizontal: "middle" },
          padding: 0,
          hidden: true,
        },
      }}
      sx={{
        [`& .${pieArcLabelClasses.root}`]: {
          fill: "white",
          fontSize: "12px",
          fontWeight: "bold",
        },
        zIndex: 1500,
      }}
      width={isSurvey ? 200 : 280}
      height={200}
      /* tooltip={{ trigger: "item", itemContent: CustomItemTooltipContent }} */
    />
  );
};
